<div *ngIf="!uploadFile">
	<p class="modal-header font-bold">Create a new mortgage</p>

	<div class="flex flex-col">
		<div class="tagline mt-2 mb-5">
			<p class="font-bold">Select a mortgage instruction source</p>
			<p class="text-sm text-grey">
				Select an option below to add mortgage instructions to this file.
			</p>
		</div>

		<div class="flex flex-col gap-4 items-center justify-center w-full">
			<div
				[class.selected]="selected === types.LLC"
				(click)="selected = types.LLC"
				class="mortgageSelection rounded-xl relative"
				[testHook]="testHooks.LlcMortgageInboxOption"
			>
				<div class="mortgageTagPrimary">
					<app-icon [icon]="ICON.INTEGRATED" class="mr-1"></app-icon> Integrated
				</div>
				<div class="flex justify-between h-full items-center">
					<div class="flex gap-3 items-center h-full">
						<div class="flex flex-row space-x-2">
							<div class="w-12 aspect-square">
								<img src="assets/images/integrations/llc-logo.svg" />
							</div>
							<div class="w-12 aspect-square">
								<img src="assets/images/integrations/sync-logo.png" />
							</div>
						</div>
						<p class="text-lg font-bold">Mortgage Inbox</p>
					</div>
					<div class="text-green text-2xl pr-3" *ngIf="selected === types.LLC">
						<app-icon [icon]="ICON.CHECK"></app-icon>
					</div>
				</div>
			</div>

			<div class="w-full">
				<div
					[class.selected]="selected === types.ASSYST"
					class="mortgageSelection relative"
					[ngClass]="fileType === matterFileType.REFINANCE ? 'rounded' : ''"
					(click)="selected = types.ASSYST"
					[testHook]="testHooks.AssystLenderCentreOption"
				>
					<div class="mortgageTagSecondary">
						<app-icon
							[icon]="ICON.ARROW_UP_FROM_BRACKET"
							class="mr-1"
						></app-icon>
						Manual intake
					</div>
					<div class="flex justify-between h-full items-center">
						<div class="flex gap-3 items-center h-full">
							<div class="w-14 aspect-square">
								<img src="assets/images/integrations/assyst-logo.svg" />
							</div>
							<p class="text-lg font-bold">Assyst / Lender Centre</p>
						</div>
						<div
							class="text-green text-2xl pr-3"
							*ngIf="selected === types.ASSYST"
						>
							<app-icon [icon]="ICON.CHECK"></app-icon>
						</div>
					</div>
				</div>
				<div
					*ngIf="
						selected === types.ASSYST && fileType !== matterFileType.REFINANCE
					"
					class="bg-grey-veryLight p-4 rounded-b-xl border border-grey-lighter border-t-0"
					[@openClose]
				>
					<p class="font-bold">Select the mortgage type</p>
					<p class="text-grey text-sm">
						Arranged mortgages are the default type in Closer.
					</p>
					<div class="flex mt-2 gap-2 items-center w-full">
						<div
							class="mortgageTypeSelection"
							[class.selected]="
								selectedTransactionType === transactionTypes.ARRANGED
							"
							(click)="selectedTransactionType = transactionTypes.ARRANGED"
							[testHook]="testHooks.AssystArrangedType"
						>
							<p class="font-bold text-sm">Arranged</p>
							<div
								class="text-green"
								*ngIf="selectedTransactionType === transactionTypes.ARRANGED"
							>
								<app-icon [icon]="ICON.CHECK"></app-icon>
							</div>
						</div>
						<div
							class="mortgageTypeSelection"
							[class.selected]="
								selectedTransactionType === transactionTypes.BRIDGE
							"
							(click)="selectedTransactionType = transactionTypes.BRIDGE"
							[testHook]="testHooks.AssystBridgeType"
						>
							<p class="font-bold text-sm">Bridge finance</p>
							<div
								class="text-green"
								*ngIf="selectedTransactionType === transactionTypes.BRIDGE"
							>
								<app-icon [icon]="ICON.CHECK"></app-icon>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="w-full">
				<div
					[class.selected]="selected === types.EMAIL"
					class="mortgageSelection relative"
					[ngClass]="fileType === matterFileType.REFINANCE ? 'rounded' : ''"
					(click)="selected = types.EMAIL"
					[testHook]="testHooks.EmailMortgageOption"
				>
					<div class="mortgageTagSecondary">
						<app-icon
							[icon]="ICON.ARROW_UP_FROM_BRACKET"
							class="mr-1"
						></app-icon>
						Manual intake
					</div>
					<div class="flex justify-between h-full items-center">
						<div class="flex gap-3 items-center h-full">
							<div
								class="flex justify-center items-center rounded-md bg-grey-veryLight w-14 h-14 aspect-square"
							>
								<app-icon [icon]="ICON.EMAIL" class="text-3xl"></app-icon>
							</div>
							<p class="text-lg font-bold">Email</p>
						</div>
						<div
							class="text-green text-2xl pr-3"
							*ngIf="selected === types.EMAIL"
						>
							<app-icon [icon]="ICON.CHECK"></app-icon>
						</div>
					</div>
				</div>
				<div
					*ngIf="
						selected === types.EMAIL && fileType !== matterFileType.REFINANCE
					"
					class="bg-grey-veryLight p-4 rounded-b-xl border border-grey-lighter border-t-0"
					[@openClose]
				>
					<p class="font-bold">Select the mortgage type</p>
					<p class="text-grey text-sm">
						Arranged mortgages are the default type in Closer.
					</p>
					<div class="flex mt-2 gap-2 items-center w-full">
						<div
							class="mortgageTypeSelection"
							[class.selected]="
								selectedTransactionType === transactionTypes.ARRANGED
							"
							(click)="selectedTransactionType = transactionTypes.ARRANGED"
							[testHook]="testHooks.EmailArrangedType"
						>
							<p class="font-bold text-sm">Arranged</p>
							<div
								class="text-green"
								*ngIf="selectedTransactionType === transactionTypes.ARRANGED"
							>
								<app-icon [icon]="ICON.CHECK"></app-icon>
							</div>
						</div>
						<div
							class="mortgageTypeSelection"
							[class.selected]="
								selectedTransactionType === transactionTypes.BRIDGE
							"
							(click)="selectedTransactionType = transactionTypes.BRIDGE"
							[testHook]="testHooks.EmailBridgeType"
						>
							<p class="font-bold text-sm">Bridge finance</p>
							<div
								class="text-green"
								*ngIf="selectedTransactionType === transactionTypes.BRIDGE"
							>
								<app-icon [icon]="ICON.CHECK"></app-icon>
							</div>
						</div>
						<div
							*ngIf="canAddVtbMortgage$ | async"
							class="mortgageTypeSelection"
							[class.selected]="
								selectedTransactionType === transactionTypes.VTB
							"
							(click)="selectedTransactionType = transactionTypes.VTB"
							[testHook]="testHooks.EmailVtbType"
						>
							<p class="font-bold text-sm">VTB</p>
							<div
								class="text-green"
								*ngIf="selectedTransactionType === transactionTypes.VTB"
							>
								<app-icon [icon]="ICON.CHECK"></app-icon>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="w-full">
				<div
					[class.selected]="selected === types.FAX"
					class="mortgageSelection relative"
					[ngClass]="fileType === matterFileType.REFINANCE ? 'rounded' : ''"
					(click)="selected = types.FAX"
					[testHook]="testHooks.FaxMortgageOption"
				>
					<div class="mortgageTagSecondary">
						<app-icon
							[icon]="ICON.ARROW_UP_FROM_BRACKET"
							class="mr-1"
						></app-icon>
						Manual intake
					</div>
					<div class="flex justify-between h-full items-center">
						<div class="flex gap-3 items-center h-full">
							<div
								class="flex justify-center items-center rounded-md bg-grey-veryLight w-14 h-14 aspect-square"
							>
								<app-icon [icon]="ICON.FAX" class="text-3xl"></app-icon>
							</div>
							<p class="text-lg font-bold">Fax</p>
						</div>
						<div
							class="text-green text-2xl pr-3"
							*ngIf="selected === types.FAX"
						>
							<app-icon [icon]="ICON.CHECK"></app-icon>
						</div>
					</div>
				</div>
				<div
					*ngIf="
						selected === types.FAX && fileType !== matterFileType.REFINANCE
					"
					class="bg-grey-veryLight p-4 rounded-b-xl border border-grey-lighter border-t-0"
					[@openClose]
				>
					<p class="font-bold">Select the mortgage type</p>
					<p class="text-grey text-sm">
						Arranged mortgages are the default type in Closer.
					</p>
					<div class="flex mt-2 gap-2 items-center w-full">
						<div
							class="mortgageTypeSelection"
							[class.selected]="
								selectedTransactionType === transactionTypes.ARRANGED
							"
							(click)="selectedTransactionType = transactionTypes.ARRANGED"
							[testHook]="testHooks.FaxArrangedType"
						>
							<p class="font-bold text-sm">Arranged</p>
							<div
								class="text-green"
								*ngIf="selectedTransactionType === transactionTypes.ARRANGED"
							>
								<app-icon [icon]="ICON.CHECK"></app-icon>
							</div>
						</div>
						<div
							class="mortgageTypeSelection"
							[class.selected]="
								selectedTransactionType === transactionTypes.BRIDGE
							"
							(click)="selectedTransactionType = transactionTypes.BRIDGE"
							[testHook]="testHooks.FaxBridgeType"
						>
							<p class="font-bold text-sm">Bridge finance</p>
							<div
								class="text-green"
								*ngIf="selectedTransactionType === transactionTypes.BRIDGE"
							>
								<app-icon [icon]="ICON.CHECK"></app-icon>
							</div>
						</div>

						<div
							*ngIf="canAddVtbMortgage$ | async"
							class="mortgageTypeSelection"
							[class.selected]="
								selectedTransactionType === transactionTypes.VTB
							"
							(click)="selectedTransactionType = transactionTypes.VTB"
							[testHook]="testHooks.FaxVtbType"
						>
							<p class="font-bold text-sm">VTB</p>
							<div
								class="text-green"
								*ngIf="selectedTransactionType === transactionTypes.VTB"
							>
								<app-icon [icon]="ICON.CHECK"></app-icon>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="flex justify-between mt-10">
			<app-button
				(click)="close()"
				btn="border"
				size="small"
				[testHook]="testHooks.CancelButton"
				>Cancel</app-button
			>
			<app-button
				[disabled]="!selected || saving"
				(onClick)="continue()"
				size="small"
				[loading]="saving"
				[testHook]="testHooks.ContinueButton"
				>Continue</app-button
			>
		</div>
	</div>
	<div *ngIf="uploadFile">
		<atomic-file-upload
			type="dropzone"
			label="Upload Lender Centre XML"
			[fileTypeList]="fileUploadTypes"
			(fileSelected)="xmlSelected($event)"
		></atomic-file-upload>

		<div class="flex justify-between mt-10">
			<app-button
				btn="secondary"
				(onClick)="backToSelect()"
				size="small"
				[testHook]="testHooks.BackButton"
				>Back</app-button
			>
		</div>
	</div>
</div>
